export default "__VITE_ASSET__CJSDJEPn__"